// Copyright (c) 2016 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import PipProductDetails from '../components/pip-details';
import PipProgramDetails from '../../pip-search/components/pip-program-details';
import {isLengthWithinRange} from '../../../shared/services/validation-service';

const validatePip = queryString => {

    const pipMaxLength = 12;
    const pipMinLength = 4;

    return isLengthWithinRange(queryString, pipMaxLength, pipMinLength);

};

const validatePin = queryString => {

    const pinMaxLength = 17;
    const pinMinLength = 6;

    return isLengthWithinRange(queryString, pinMaxLength, pinMinLength);

};

const getPinFilterOptions = () => [
    [
        'pin'
    ],
    [
        'customerSummary',
        'displayName'
    ],
    [
        'leadAccount',
        'account'
    ],
    [
        'responsibleAccount',
        'name'
    ],
    [
        'responsibleAccount',
        'account'
    ],
    [
        'leadAccount',
        'name'
    ],
    [
        'model'
    ],
    [
        'pipStatus',
        'key'
    ],
    [
        'pipType',
        'key'
    ],
    [
        'dtac'
    ],
    [
        'description'
    ]
];

const getPipFilterOptions = () => [
    [
        'pipId'
    ],
    [
        'metric',
        'key'
    ],
    [
        'pipStatus',
        'key'
    ],
    [
        'pipType',
        'key'
    ],
    [
        'dtac'
    ]
];

export const mapPipValidation = (key, queryString) => {

    const map = {
        PIN: validatePin,
        PIP: validatePip
    };

    return map[key](queryString);

};

export const mapSearchPlaceHolder = key => {

    const map = {
        PIN: 'SEARCH_PRODUCT_BY_PIN_PLACEHOLDER',
        PIP: 'SEARCH_PRODUCT_BY_PIP_PLACEHOLDER'
    };

    return map[key];

};

export const mapValidationErrorMessages = key => {

    const map = {
        PIN: 'SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL',
        PIP: 'SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL'
    };

    return map[key];

};

export const getPinSortOptions = () => [
    {
        displayName: 'EXPIRES',
        path: [
            'expireDate'
        ]
    },
    {
        displayName: 'STARTS',
        path: [
            'startDate'
        ]
    },
    {
        displayName: 'RESPONSIBLE_DEALER',
        path: [
            'responsibleAccount',
            'account'
        ]
    },
    {
        displayName: 'PIN',
        path: [
            'pin'
        ]
    },
    {
        displayName: 'PIP_NUMBER',
        path: [
            'pipNumber'
        ]
    }
];

export const getPipSortOptions = () => [
    {
        displayName: 'EXPIRES',
        path: [
            'expireDate'
        ]
    },
    {
        displayName: 'STARTS',
        path: [
            'startDate'
        ]
    },
    {
        displayName: 'PIP_NUMBER',
        path: [
            'pipNumber'
        ]
    }
];

export const showValidationError = (formatMessage, key) =>
    errorAlertBar(createErrorObject(formatMessage({
        id: key
    })));

export const pipSearchViewMap = key => {

    const map = {
        PIN: PipProductDetails,
        PIP: PipProgramDetails
    };

    return map[key];

};

export const mapRouteDetails = (key, pip) => {

    const map = {
        PIN: {
            label: pip.pin,
            route: `/products/${pip.pin}`
        },
        PIP: {
            label: pip.description,
            route: `/pips/programs/${pip.pipId}`
        }
    };

    return map[key];

};

const filterItemOnDealers = (accountNumber, selectedDealers) =>
    selectedDealers.some(item => item.account === accountNumber);

const filterItemOnKeyValueTypes = (itemToCompare, selectedItems) =>
    selectedItems.some(item => item.key === itemToCompare.key);

const filterByPin = pipSearchDetails =>
    pipSearchDetails.searchResults.filter(item =>
        filterItemOnDealers(item.leadAccount.account, pipSearchDetails.selectedDealers) && filterItemOnKeyValueTypes(item.pipType, pipSearchDetails.selectedPipTypes)
    );

const filterByPip = pipSearchDetails =>
    pipSearchDetails.searchResults.filter(item =>
        filterItemOnKeyValueTypes(item.pipType, pipSearchDetails.selectedPipTypes)
    );

export const filterSearchResults = pipSearchDetails => {

    const method = pipSearchDetails.searchByType === 'PIN' && pipSearchDetails.isValidDealer ?
        filterByPin :
        filterByPip;

    return method(pipSearchDetails);

};

export const getFilterOptions = type =>
    type === 'PIN' ?
        getPinFilterOptions() :
        getPipFilterOptions();

export const getSortOptions = type =>
    type === 'PIN' ?
        getPinSortOptions() :
        getPipSortOptions();

export const mapExcelEndPoints = (query, key, language, layoutName) => {

    const basePath = '/api';

    const map = {
        PIN: `${basePath}/pip-products/search?by=${key}&q=${encodeURIComponent(query)}&export=EXCEL&language=${language}&layout=${encodeURIComponent(layoutName)}&listId=pipProductSearch`,
        PIP: `${basePath}/pips/search?by=${key}&q=${encodeURIComponent(query)}&export=EXCEL&language=${language}&layout=${encodeURIComponent(layoutName)}&listId=pipSearch`
    };

    return map[key];

};



// WEBPACK FOOTER //
// ./src/pip/shared/services/pip-search-helper.js